import { IntroPage, Review as ReviewInterface } from 'types';
import introPage from './introPage.json';
export const Intro = introPage.Intro as IntroPage;
export const Review = introPage.Review as ReviewInterface;
export { default as errors } from './errors.json';
export { default as footer } from './footer.json';
export { default as form } from './form.json';
export { default as funnel } from './funnel.json';
export { default as funnelWaitingScreens } from './funnelWaitingScreens.json';
export { default as global } from './global.json';
export { default as googleMap } from './map.json';
export { default as offer } from './offer.json';

export { default as relationship } from './relationship.json';
